/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { chatListSessionLinks } from "../funcs/chatListSessionLinks.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListSessionLinksResult } from "../models/components/listsessionlinksresult.js";
import {
  ListChatSessionLinksRequest,
  ListChatSessionLinksSecurity,
} from "../models/operations/listchatsessionlinks.js";
import { unwrapAsync } from "../types/fp.js";
export type ListChatSessionLinksQueryData = ListSessionLinksResult;

export function prefetchListChatSessionLinks(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListChatSessionLinksRequest,
  security?: ListChatSessionLinksSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListChatSessionLinksQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListChatSessionLinksQuery(
  client$: GramCore,
  request: ListChatSessionLinksRequest,
  security?: ListChatSessionLinksSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListChatSessionLinksQueryData>;
} {
  return {
    queryKey: queryKeyListChatSessionLinks({
      chatIds: request.chatIds,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
      gramChatSession: request.gramChatSession,
    }),
    queryFn: async function listChatSessionLinksQueryFn(
      ctx,
    ): Promise<ListChatSessionLinksQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(chatListSessionLinks(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListChatSessionLinks(
  parameters: {
    chatIds: Array<string>;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
    gramChatSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "chat", "listSessionLinks", parameters];
}
